import React, { useState } from 'react';
import {
  Button,
  Menu,
  TextField,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { Link as LinkIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import isValidUrl from '../../../../../helpers/selectors/isValidUrl';

const EditLinkPopover = ({ onSetLink }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [link, setLink] = useState('');
  const [openInNewTab, setOpenInNewTab] = useState(false);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => {
    setAnchorEl(null);
    setLink('');
    setOpenInNewTab(false);
  };

  const handleApply = () => {
    if (!isValidUrl(link)) return; // do nothing if not valid
    onSetLink(link, openInNewTab);
    handleClose();
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        startIcon={<LinkIcon />}
        className="text-xs normal-case "
      >
        Link
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} className="modal-safe-click-zone">
        <div className="p-4 w-64 space-y-3 ">
          <p className="text-sm text-gray-700 italic px-2">Start with http:// or https://</p>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            label="Enter URL"
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
          <FormControlLabel
            control={(
              <Checkbox
                checked={openInNewTab}
                onChange={(e) => setOpenInNewTab(e.target.checked)}
                color="primary"
              />
            )}
            label="Open in new tab"
          />
          <Button
            onClick={handleApply}
            variant="contained"
            color="primary"
            fullWidth
            disabled={!isValidUrl(link)}
          >
            Apply
          </Button>
        </div>
      </Menu>
    </>
  );
};
EditLinkPopover.propTypes = {
  onSetLink: PropTypes.func.isRequired,
};
export default EditLinkPopover;
